/*
  Warranty cart nudge (Nova Wax, Turbo theme). Port of the Starpil Task 4 nudge.

  Any warmer line in the cart without a paired 2-Year Extended Protection line gets an
  "Add 2 year protection +$X" button. One click adds the matching plan with the same four
  `_covers_*` properties the product page sends, so Flows A and B treat it identically.

  Turbo draws cart lines in three places: the Liquid mini-cart in the header (first paint),
  the same mini-cart rebuilt by app.js after every AJAX add, and the cart page. All three mark
  each line `[data-cart-item][data-line-id][data-variant-id]`, so this script decorates rows
  wherever they appear and re-runs whenever Turbo swaps the cart HTML.

  Needs window.NovaWarrantyMap (snippets/warranty-cart-data.liquid) and, for a no-reload drawer
  refresh, window.NovaRefreshCart (exposed from Turbo's app.js.liquid).
*/
(function () {
  if (window.__novaWarrantyNudge) return;
  window.__novaWarrantyNudge = true;

  var GID_PREFIX = 'gid://shopify/ProductVariant/';
  var TERM = '2yr';
  var ROW_SELECTOR = '[data-cart-item][data-line-id][data-variant-id]';
  var HOST_SELECTOR = '.mini-cart__item-content, .cart__item--content';

  var running = false;
  var queued = false;

  function map() {
    return window.NovaWarrantyMap || {};
  }

  function money(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.PXUTheme && window.PXUTheme.currency && window.PXUTheme.currency.money_format);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function isCovered(cart, variantId) {
    var needle = GID_PREFIX + variantId;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.product_type === 'Warranty' && it.properties && it.properties._covers_variant === needle) return true;
    }
    return false;
  }

  function needsNudge(cart, line) {
    if (!line || line.product_type === 'Warranty') return null;
    var entry = map()[String(line.product_id)];
    if (!entry || !entry.a || !line.sku) return null;
    if (isCovered(cart, line.variant_id)) return null;
    return entry;
  }

  function build(line, entry) {
    var wrap = document.createElement('div');
    wrap.className = 'warranty-nudge';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'warranty-nudge__btn';
    btn.setAttribute('aria-label', 'Add 2 year protection for ' + line.product_title + ', ' + money(entry.p));

    var box = document.createElement('span');
    box.className = 'warranty-nudge__box';
    box.setAttribute('aria-hidden', 'true');

    var label = document.createElement('span');
    label.className = 'warranty-nudge__label';
    var strong = document.createElement('strong');
    strong.textContent = 'Add 2 year protection';
    label.appendChild(strong);

    var price = document.createElement('span');
    price.className = 'warranty-nudge__price';
    price.textContent = '+' + money(entry.p);

    btn.appendChild(box);
    btn.appendChild(label);
    btn.appendChild(price);
    wrap.appendChild(btn);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      add(line, entry, btn, wrap);
    });

    return wrap;
  }

  function add(line, entry, btn, wrap) {
    if (btn.disabled) return;
    btn.disabled = true;
    var old = wrap.querySelector('.warranty-nudge__error');
    if (old) old.remove();

    var payload = {
      items: [{
        id: entry.v,
        quantity: line.quantity,
        properties: {
          _covers_sku: line.sku,
          _covers_variant: GID_PREFIX + line.variant_id,
          _covers_title: line.product_title,
          _term: TERM
        }
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed ' + r.status);
        return r.json();
      })
      .then(function () {
        // The cart page is server-rendered; the drawer can redraw in place.
        if (document.body.classList.contains('cart') || typeof window.NovaRefreshCart !== 'function') {
          window.location.reload();
          return;
        }
        return getCart().then(function (cart) { window.NovaRefreshCart(cart); });
      })
      .catch(function () {
        btn.disabled = false;
        var err = document.createElement('span');
        err.className = 'warranty-nudge__error';
        err.textContent = 'Could not add protection. Please try again.';
        wrap.appendChild(err);
      });
  }

  function decorate() {
    if (running) { queued = true; return; }
    if (!document.querySelector(ROW_SELECTOR)) return;
    running = true;

    getCart()
      .then(function (cart) {
        var rows = document.querySelectorAll(ROW_SELECTOR);
        for (var i = 0; i < rows.length; i++) {
          var row = rows[i];
          var existing = row.querySelector('.warranty-nudge');
          var line = cart.items[parseInt(row.getAttribute('data-line-id'), 10) - 1];
          var matches = line && String(line.variant_id) === row.getAttribute('data-variant-id');
          var entry = matches ? needsNudge(cart, line) : null;

          if (!entry) {
            if (existing) existing.remove();
            continue;
          }
          if (existing) continue;

          var host = row.querySelector(HOST_SELECTOR);
          if (host) host.appendChild(build(line, entry));
        }
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (queued) { queued = false; decorate(); }
      });
  }

  // Re-run when Turbo swaps cart HTML, but ignore our own nudge insertions.
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(decorate, 60);
  }

  function relevant(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.classList && node.classList.contains('warranty-nudge')) return false;
    if (node.closest && node.closest('.warranty-nudge')) return false;
    return (node.matches && node.matches(ROW_SELECTOR)) || !!(node.querySelector && node.querySelector(ROW_SELECTOR));
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (relevant(added[j])) { schedule(); return; }
      }
    }
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    decorate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
